import { tv as e } from "tailwind-variants";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/Spinner/Spinner.tsx
var n = e({
	slots: {
		spinner: "animate-spin",
		wrapper: ""
	},
	variants: {
		size: {
			xs: { spinner: "size-4" },
			sm: { spinner: "size-6" },
			md: { spinner: "size-8" },
			lg: { spinner: "size-10" },
			xl: { spinner: "size-12" },
			"2xl": { spinner: "size-28" }
		},
		color: {
			neutral: { spinner: "text-neutral-600" },
			primary: { spinner: "text-ic-primary" },
			white: { spinner: "text-white" }
		},
		position: {
			default: { wrapper: "" },
			center: { wrapper: "flex h-dvh items-center justify-center" }
		}
	},
	defaultVariants: {
		size: "xl",
		color: "neutral",
		position: "default"
	}
});
function r(e) {
	let { color: r, size: i, position: a, className: o } = e, { spinner: s, wrapper: c } = n({
		color: r,
		size: i,
		position: a
	});
	return /* @__PURE__ */ t("div", {
		className: c(),
		children: /* @__PURE__ */ t("svg", {
			className: s({ className: o }),
			viewBox: "0 0 64 64",
			fill: "none",
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			children: /* @__PURE__ */ t("path", {
				d: "M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762",
				stroke: "currentColor",
				strokeWidth: "5",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		})
	});
}
//#endregion
export { r as Spinner };
